import React from 'react';
import withIcon from '../utilities/withIcon';

const IconNumber8 = () => {
  return (
    <g>
      <path d="m7.9518 8.4081c-.8518 0-1.4268.4482-1.4268 1.2419s.575 1.2317 1.4268 1.2317c.8633 0 1.4385-.4375 1.4385-1.2315s-.5752-1.2421-1.4385-1.2421z" />
      <path d="m7.9518 7.3378a1.119 1.119 0 0 0 1.2539-1.1621 1.1052 1.1052 0 0 0 -1.2539-1.15 1.096 1.096 0 0 0 -1.2418 1.15 1.11 1.11 0 0 0 1.2418 1.1621z" />
      <path d="m8 .1819a7.8181 7.8181 0 1 0 7.818 7.8181 7.818 7.818 0 0 0 -7.818-7.8181zm-.0482 11.7692c-1.7139 0-2.8418-.8511-2.8418-2.1973a1.957 1.957 0 0 1 1.542-1.875v-.0235a1.7811 1.7811 0 0 1 -1.2891-1.7832c0-1.22 1.0127-2.082 2.5889-2.082 1.5879 0 2.6006.8623 2.6006 2.082a1.7811 1.7811 0 0 1 -1.2891 1.7833v.0234a1.957 1.957 0 0 1 1.542 1.875c0 1.3462-1.1279 2.1973-2.8535 2.1973z" />
    </g>
  );
};

export default withIcon(IconNumber8);
